module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/util/support/isBufferBrowser.js
// module id = ../../../../util/support/isBufferBrowser.js
// module chunks = 5